import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
// import { ProductService } from "./ProductService";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

import { Toolbar } from "primereact/toolbar";

import { Dialog } from "primereact/dialog";

// import * as XLSX from "xlsx";
import { Link, useParams } from "react-router-dom";
import { InputSwitch } from "primereact/inputswitch";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector } from "react-redux";
// import { Dropdown } from "react-bootstrap";
// import { AiOutlineDelete } from "react-icons/ai";

export default function CountryTable() {
  let emptyProduct = {
    phone: "",
    name: "",
    CONTACTS: "",
    image: null,
    description: "",
    category: null,
    price: 0,
    quantity: 0,
    rating: 0,
    inventoryStatus: "INSTOCK",
  };
  const { user } = useSelector((state) => state.auth);
  const [products, setProducts] = useState(null);
  const [productDialog, setProductDialog] = useState(false);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
  const [product, setProduct] = useState(emptyProduct);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const [data, setData] = useState();
  const [datagetway, setDatagetway] = useState();
  const [smsGetWay, setSmsGetWay] = useState();
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [messagePrice, setMessagePrice] = useState("");
  const [name, setName] = useState("");
  const [maxNumbersLink, setmaxNumbersLink] = useState("");
  const [pointsLink, setpointsLink] = useState("");
  const [englishLink, setenglishLink] = useState("");
  const [arabicLick, setarabicLick] = useState("");
  const [userPassword, setuserPassword] = useState("");
  const [userName, setuserName] = useState("");
  const [successResult, setsuccessResult] = useState("");
  const [countryCode, setcountryCode] = useState("");
  const [code, setcode] = useState("");
  const [currencyName, setcurrencyName] = useState("");
  const [symbol, setsymbol] = useState("");

  const [isActive, setisActive] = useState("");

  const [dataCountryName, setDataCountryName] = useState({
    countryName: { en: "", ar: "" },
  });
  const [currency, setCurrency] = useState("");
  const [packageType, setPackageType] = useState("");
  const [display, setDisplay] = useState("");
  const [editRow, setEditRow] = useState("");

  const [errorAr, setErrorAr] = useState("");
  const [errorEn, setErrorEn] = useState("");

  const fileInputRef = useRef(null);

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const getData = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.get(
        `https://mytinkle.net/country`,

        config,
        config
      );
      console.log("editReditRow", res);
      if (res) {
        setData(res);

        // setTotalPages(res.data.total / 10);
      } else {
        console.log(res);
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);

      //  setError(true);
    }
  };
  const getDataGetway = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.get(
        `https://mytinkle.net/smsGetWay`,

        config,
        config
      );
      if (res) {
        setDatagetway(res);

        // setTotalPages(res.data.total / 10);
      } else {
        console.log(res);
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);

      //  setError(true);
    }
  };

  useEffect(() => {
    getData();
    getDataGetway();
  }, []);

  const handleChangeCountry = (event) => {
    const { name, value } = event.target;
    const [parent, child] = name.split(".");
    setDataCountryName((prev) => ({
      ...prev,
      [parent]: { ...prev[parent], [child]: value },
    }));
  };

  ///sendData
  const sendData = async (e) => {
    e.preventDefault();

    if (!dataCountryName.countryName.en) {
      setErrorEn("Please enter country name in English");
      return;
    }

    if (!dataCountryName.countryName.ar) {
      setErrorAr("Please enter country name in Arabic");
      return;
    }
    setName("");
    if (name != "") {
      hideDialog();
    }
    // setLoading(true);

    const data2 = {
      countryName: dataCountryName.countryName,
      countryCode: countryCode,
      code: code,
      symbol: symbol,
      smsGetWay: smsGetWay,
      currencyName: currencyName,
      // isActive: isActive === true ? "true" : "false",
      isActive: isActive,
    };
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      console.log("data", data2);
      const res = await axios.post(
        `https://mytinkle.net/country/create`,
        data2,
        config
      );

      console.log(res);
      hideDialog();
      if (res) {
        //  dispatch(adminVerfiy(data));
        getData();
        // setLoading(false);
        // setLoading(false);
        setName("");
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });
      } else {
        hideDialog();
        console.log(res);
        // setLoading(false);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res?.message,
          life: 3000,
        });
        hideDialog();
      }
    } catch (error) {
      // setLoading(false);
      hideDialog();
      console.log("err", error);
      //   setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        // detail: error.response.data.message,
        life: 3000,
      });
      //  setError(true);
    }
  };

  const handleEdit = async () => {
    // setLoading(true);

    if (
      !dataCountryName?.countryName?.en?.trim() &&
      !editRow?.countryName?.en?.trim()
    ) {
      setErrorEn("Please enter country name in English");
      return;
    }

    if (
      !dataCountryName?.countryName?.ar?.trim() &&
      !editRow?.countryName?.ar?.trim()
    ) {
      setErrorAr("Please enter country name in Arabic");
      return;
    }

    hideDialog();

    const data2 = {
      countryName: {
        en:
          dataCountryName?.countryName?.en?.trim() || editRow?.countryName?.en,
        ar:
          dataCountryName?.countryName?.ar?.trim() || editRow?.countryName?.ar,
      },
      countryCode: countryCode || editRow.countryCode,
      code: code || editRow.code,
      symbol: symbol || editRow.symbol,
      smsGetWay: smsGetWay || editRow.smsGetWay,
      currencyName: currencyName || editRow.currencyName,
      isActive: isActive !== undefined ? isActive : editRow.isActive,
    };
    console.log("data2", data2);
    console.log("editRow", editRow);

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.patch(
        `https://mytinkle.net/country/update/${editRow._id}`,
        data2,
        config
      );
      console.log(res);
      setEditRow("");
      if (res) {
        getData();
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });

        // setLoading(false);
      } else {
        console.log(res);
        // setLoading(false);
      }
    } catch (error) {
      console.log(error);
      //   setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        // detail: error.response.data.message,
        life: 3000,
      });
      //  setError(true);
    }
  };

  // const handleDelete = async (deleteProductDialog) => {
  //   setDeleteProductDialog(false);
  //   hideDialog();
  //   setEditRow("");
  //   // setRowDelete("");

  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Access-Control-Allow-Origin": "*",
  //         withCredentials: false,
  //         Authorization: `Bearer ${user.token}`,
  //       },
  //     };
  //     const res = await axios.delete(
  //       `https://mytinkle.net/country/delete/${deleteProductDialog._id}`,
  //       config
  //     );
  //     console.log(res);
  //     if (res) {
  //       getData();
  //       toast.current.show({
  //         severity: "success",
  //         summary: "Successful",
  //         detail: res.message,
  //         life: 3000,
  //       });
  //     } else {
  //       console.log(res);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: error.message,
  //       life: 3000,
  //     });
  //     //  setError(true);
  //   }
  // };

  const openNew = () => {
    setSubmitted(false);
    setProductDialog(true);
  };

  const hideDialog = () => {
    setEditRow("");
    setSubmitted(false);
    setProductDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteProductsDialog(false);
  };

  const saveProduct = () => {
    setSubmitted(true);

    if (product.name.trim()) {
      let _products = [...products];
      let _product = { ...product };

      if (product.id) {
        const index = findIndexById(product.id);

        _products[index] = _product;
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Product Updated",
          life: 3000,
        });
      } else {
        _product.id = createId();
        _product.image = "product-placeholder.svg";
        _products.push(_product);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Product Created",
          life: 3000,
        });
      }

      setProducts(_products);
      setProductDialog(false);
      setProduct(emptyProduct);
    }
  };

  const editProduct = (product) => {
    setProduct({ ...product });
    setProductDialog(true);
  };

  const confirmDeleteProduct = (product) => {
    setProduct(product);

    setDeleteProductDialog(product);
  };

  const deleteProduct = () => {
    let _products = products.filter((val) => val.id !== product.id);

    setProducts(_products);
    setDeleteProductDialog(false);
    setProduct(emptyProduct);
    toast.current.show({
      severity: "success",
      summary: "Successful",
      detail: "Product Deleted",
      life: 3000,
    });
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < products.length; i++) {
      if (products[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteProductsDialog(true);
  };

  const deleteSelectedProducts = () => {
    let _products = products.filter((val) => !selectedProducts.includes(val));

    setProducts(_products);
    setDeleteProductsDialog(false);
    setSelectedProducts(null);
    toast.current.show({
      severity: "success",
      summary: "Successful",
      detail: "Products Deleted",
      life: 3000,
    });
  };

  const onCategoryChange = (e) => {
    let _product = { ...product };

    _product["category"] = e.value;
    setProduct(_product);
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _product = { ...product };

    _product[`${name}`] = val;

    setProduct(_product);
  };

  const onInputNumberChange = (e, name) => {
    const val = e.value || 0;
    let _product = { ...product };

    _product[`${name}`] = val;

    setProduct(_product);
  };
  const parms = useParams();
  const exportToExcel = () => {
    const exportData = selectedProducts.map((product) => ({
      id: product?.id || "", // Use optional chaining and default value
      Name: product?.name || "",
      Price: product?.price || 0,
      Category: product?.category || "",
      Rating: product?.rating || 0,
      InventoryStatus: product?.inventoryStatus || "",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");

    XLSX.writeFile(wb, "exported_products.xlsx");
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="flex  flex-wrap fs-5 gap-3">
        <Button
          color="success"
          className="add-btn me-1 bg-gradient bg-success"
          onClick={openNew}
          id="create-btn"
        >
          <i className="ri-add-line align-bottom me-1"></i> Add Country
        </Button>
      </div>
    );
  };

  const actionEdit = (rowData) => {
    console.log(rowData);
    return (
      <React.Fragment>
        <div className="d-flex gap-2">
          <Button
            className=" bg-gradient	 py-1 px-2"
            onClick={() => {
              setProductDialog(true);
              setEditRow(rowData);
            }}
          >
            <i className=" ri-edit-box-line text-info-emphasis cursor-pointe"></i>
          </Button>
        </div>
      </React.Fragment>
    );
  };
  const actionDelete = (rowData) => {
    return (
      <React.Fragment>
        <div className="d-flex gap-2">
          <Button
            className=" bg-danger py-1 px-2"
            onClick={() => confirmDeleteProduct(rowData)}
          >
            <i className="ri-delete-bin-2-line bg-danger"></i>
          </Button>
        </div>
      </React.Fragment>
    );
  };

  const getSeverity = (product) => {
    switch (product.inventoryStatus) {
      case "INSTOCK":
        return "success";

      case "LOWSTOCK":
        return "warning";

      case "OUTOFSTOCK":
        return "danger";

      default:
        return null;
    }
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between col-12">
      <span className="p-input-icon-left col-12 col-md-6">
        <i className="pi pi-search" />
        <div class="form-floating mb-4">
          <input
            id="textInputExample"
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
            class="form-control"
          />
          <label for="textInputExample">Search...</label>
        </div>
      </span>
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button label="Save" icon="pi pi-check" onClick={saveProduct} />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );
  const exportSelectedToExcel = () => {
    if (selectedProducts && selectedProducts.length > 0) {
      const selectedRows = products.filter((product) =>
        selectedProducts.includes(product.id)
      );

      const exportData = selectedRows.map((product) => ({
        Name: product.name,
        Description: product.description,
        Price: product.price,
        Category: product.category,
        Rating: product.rating,
        InventoryStatus: product.inventoryStatus,
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SelectedProducts");

      XLSX.writeFile(wb, "selected_products.xlsx");
    }
  };
  const nameBodyTemplate = (rowData) => {
    return <Link to={`/smspro-groups_grid/${rowData.id}`}>{rowData.name}</Link>;
  };
  const [checked, setChecked] = useState(false);

  const handleToggleChange = (rowData, value) => {
    setCheckedRows((prevCheckedRows) => ({
      ...prevCheckedRows,
      [rowData.id]: value,
    }));
  };

  const statusBodyTemplate2 = (rowData) => {
    return (
      <InputSwitch
        checked={checkedRows[rowData.id] || false}
        onChange={(e) => handleToggleChange(rowData, e.value)}
      />
    );
  };

  const [checkedRows, setCheckedRows] = useState({});
  const handleExcelUpload = (event) => {
    const file = event.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0]; // Assuming first sheet

      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      setProducts((prevProducts) => [...prevProducts, ...jsonData]);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Data Imported",
        life: 3000,
      });
    };

    reader.readAsArrayBuffer(file);
  };

  const [uploadedExcelData, setUploadedExcelData] = useState([]);

  const handleUploadExcel = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      setUploadedExcelData(jsonData);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Excel Data Uploaded",
        life: 3000,
      });
    };

    reader.readAsArrayBuffer(file);
  };

  const [t, i18n] = useTranslation();
  const [importExcel, setImportExcel] = useState(false);
  return (
    <div>
      <Toast ref={toast} />

      <div className="card-body">
        <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>

        <input
          id="upload-excel-input"
          type="file"
          accept=".xlsx, .xls"
          style={{ display: "none" }}
          onChange={handleUploadExcel}
        />

        <DataTable
          ref={dt}
          value={data}
          selection={selectedProducts}
          onSelectionChange={(e) => setSelectedProducts(e.value)}
          // dataKey="id"
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
          globalFilter={globalFilter}
          header={header}

          //   selectionMode={"checkbox"}
        >
          <Column
            className="fs-13"
            field="countryName.en"
            header="Country Name En"
          ></Column>

          <Column
            className="fs-13"
            field="countryName.ar"
            header="Country Name Ar"
          ></Column>

          <Column
            className="fs-13"
            field="countryCode"
            header="Country Code"
          ></Column>
          <Column className="fs-13" field="code" header="Code"></Column>
          <Column
            className="fs-13"
            field="isActive"
            header="Is Active"
          ></Column>
          <Column
            className="fs-13"
            field="usersCount"
            header="Users Count"
          ></Column>

          <Column
            className="fs-13"
            header="Edit"
            body={actionEdit}
            exportable={false}
            // style={{ minWidth: "8rem" }}
          ></Column>
          {/* <Column
            className="fs-13"
            header="Delete"
            body={actionDelete}
            exportable={false}
            // style={{ minWidth: "8rem" }}
          ></Column> */}
        </DataTable>
      </div>

      <Dialog
        visible={productDialog}
        style={{ width: "50rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header={editRow._id ? t("Edit Country") : t("Create Country")}
        modal
        className="p-fluid"
        footer={
          <React.Fragment>
            <Button
              label="Cancels"
              icon="pi pi-times"
              outlined
              onClick={hideDialog}
            />
            <Button
              label="Save"
              icon="pi pi-check"
              type="submit"
              onClick={(e) => (editRow._id ? handleEdit() : sendData(e))}
            />
          </React.Fragment>
        }
        onHide={hideDialog}
      >
        <div className="row">
          <div className="field col-12 col-xl-6">
            <label htmlFor="name1" className="font-bold">
              Country Name En
            </label>
            <div class="form-floating mb-4">
              <input
                id="name"
                type="text"
                name="countryName.en"
                onChange={handleChangeCountry}
                // value={dataCountryName.countryName.en}
                required
                class="form-control"
                defaultValue={editRow.countryName?.en || ""}
              />

              <label for="name">Country Name En</label>
              <p className="text-danger">{errorEn}</p>
            </div>
          </div>
          <div className="field col-12 col-xl-6">
            <label htmlFor="name1" className="font-bold">
              Country Name Ar
            </label>
            <div class="form-floating mb-4">
              <input
                id="name"
                type="text"
                name="countryName.ar"
                // value={dataCountryName.countryName.ar}
                onChange={handleChangeCountry}
                required
                //   autoFocus
                class="form-control"
                defaultValue={editRow.countryName?.ar || ""}
              />

              <label for="name">Country Name Ar</label>
              <p className="text-danger">{errorAr}</p>
            </div>
          </div>

          <div className="field col-12 col-xl-6">
            <label htmlFor="description" className="font-bold">
              Country Code
            </label>
            <div class="form-floating mb-4">
              <input
                id="textInputExample"
                type="text"
                class="form-control"
                placeholder="Text Input"
                required
                // value={countryCode}
                defaultValue={editRow.countryCode}
                onChange={(e) => setcountryCode(e.target.value)}
              />

              <label for="textInputExample">Country Code</label>
            </div>
          </div>

          <div className="field col-12 col-xl-6">
            <label htmlFor="code" className="font-bold">
              Code
            </label>
            <div class="form-floating mb-4">
              <input
                id="code"
                type="text"
                name="code"
                class="form-control"
                placeholder="Text Input"
                required
                defaultValue={editRow.code}
                onChange={(e) => setcode(e.target.value)}
              />

              <label for="textInputExample">Code</label>
            </div>
          </div>
          <div className="field col-12 col-xl-6">
            <label htmlFor="description" className="font-bold">
              Currency Name
            </label>
            <div class="form-floating mb-4">
              <input
                id="textInputExample"
                type="text"
                class="form-control"
                placeholder="Text Input"
                required
                defaultValue={editRow.currencyName}
                onChange={(e) => setcurrencyName(e.target.value)}
              />

              <label for="textInputExample">Currency Name</label>
            </div>
          </div>
          <div className="field col-12 col-xl-6">
            <label htmlFor="description" className="font-bold">
              Symbol
            </label>
            <div class="form-floating mb-4">
              <input
                id="textInputExample"
                type="text"
                class="form-control"
                placeholder="Text Input"
                required
                defaultValue={editRow.symbol}
                onChange={(e) => setsymbol(e.target.value)}
              />

              <label for="textInputExample"> Symbol</label>
            </div>
          </div>
          <div className="field col-12 col-xl-6">
            <label htmlFor="description" className="font-bold">
              Is Active
            </label>
            <div class="form-floating mb-4">
              <select
                class="form-select pt-1 "
                aria-label="Default select example"
                defaultValue={editRow.isActive}
                onChange={(e) => setisActive(e.target.value)}
              >
                <option selected>Is Active</option>
                <option value="true">true</option>
                <option value="false">false</option>
              </select>
            </div>
          </div>
          <div className="field col-12 col-xl-6">
            <label htmlFor="description" className="font-bold">
              Sms smsGetWay
            </label>
            <div class="form-floating mb-4 ">
              <select
                class="form-select pt-1 "
                aria-label="Default select example"
                defaultValue={editRow.smsGetWay}
                onChange={(e) => setSmsGetWay(e.target.value)}
              >
                {/* selected */}
                <option value={""}>Sms smsGetWay</option>
                {datagetway?.map((e) => (
                  <option value={e._id}>{e.name}</option>
                ))}
              </select>
            </div>
          </div>

          {/* <div className="d-flex gap-4 align-items-center col-12 col-xl-6">
            <label htmlFor="description" className="font-bold col-3 ml-4">
              Icon
            </label>

        
            <img
              src={addIcon ? URL.createObjectURL(addIcon) : editRow.icon}
              alt="Uploaded Icon"
              className="mb-2 cursor-pointer"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              onClick={() => fileInputRef.current.click()}
            />
             )} 

            <input
              ref={fileInputRef}
              type="file"
              accept="image/png, image/gif,image/jpg, image/jpeg"
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setAddIcon(file);
                }
                clearFileInput();
              }}
            />
          </div> */}
        </div>
      </Dialog>

      <Dialog
        visible={importExcel}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header={t("Upload Excel")}
        modal
        className="p-fluid"
        footer={productDialogFooter}
        onHide={() => setImportExcel(false)}
      >
        <div className="d-flex align-items-center justify-content-between ">
          <div class="form-select-wrapper col-3 d-md-block d-none">
            <label className="text-orange ">{t("Upload Excel	")}</label>
          </div>
          <div>
            <button
              label="Upload Excel"
              icon="pi pi-upload"
              className="btn btn-primary rounded-xl mx-1 fs-14"
              onClick={() =>
                document.getElementById("upload-excel-input").click()
              }
            >
              {t("Upload")}
              <i class="uil uil-export  mx-2"></i>
            </button>
          </div>
          <input
            id="upload-excel-input"
            type="file"
            accept=".xlsx, .xls"
            style={{ display: "none" }}
            //   onChange={handleUploadExcel}
          />
        </div>
      </Dialog>

      <Dialog
        visible={deleteProductDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={
          <React.Fragment>
            <Button
              label="No"
              icon="pi pi-times"
              outlined
              onClick={hideDeleteProductDialog}
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              severity="danger"
              onClick={() => handleDelete(deleteProductDialog)}
            />
          </React.Fragment>
        }
        onHide={hideDeleteProductDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {product && (
            <span>
              Are you sure you want to delete{" "}
              <b>{deleteProductDialog.countryName?.en}</b>?
            </span>
          )}
          {/* {console.log("kiki", deleteProductDialog)} */}
        </div>
      </Dialog>

      <Dialog
        visible={deleteProductsDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteProductsDialogFooter}
        onHide={hideDeleteProductsDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {product && (
            <span>Are you sure you want to delete the selected products?</span>
          )}
        </div>
      </Dialog>
    </div>
  );
}
